import Vapi from 'vuex-rest-api';

const fetcherAdminList = new Vapi({
  state: {
    fetcherAdminList: {
      id: 0,
    },
    lists: [],
  },
})
  .get({
    action: 'getFetcherAdminList',
    property: 'fetcherAdminList',
    path: ({ lid }) => `/api/fetcher/admin/lists/${lid}`,
  })
  .getStore();

export default fetcherAdminList;
